import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';

const breadcrumbItems = [
  { label: '首页', path: '/' },
  { label: '关于我们' },
];

const testimonials = [
  {
    name: '张先生',
    role: '影视爱好者',
    content: '在线观看的画质真的没话说，4K超清看大片太爽了！而且完全没广告，体验比别的平台好太多了。',
    rating: 5,
  },
  {
    name: '李女士',
    role: '全职妈妈',
    content: '小朋友专区内容很丰富，陪孩子看动画片的同时还能学到知识。多终端同步功能也很方便，手机平板随便切换。',
    rating: 5,
  },
  {
    name: '王同学',
    role: '大学生',
    content: '纪录片资源太棒了！写论文找素材全靠它。播放流畅不卡，学校网速一般的条件下也能正常看。',
    rating: 5,
  },
  {
    name: '赵先生',
    role: 'IT工程师',
    content: '技术层面做得很到位，CDN加速效果明显。目前用过的最流畅的在线视频网站，强烈推荐给身边的朋友。',
    rating: 5,
  },
  {
    name: '陈女士',
    role: '自由职业者',
    content: '追综艺全靠在线观看了，更新速度快，画质清晰。在家投屏到电视上看，效果比电视直播还好。',
    rating: 5,
  },
  {
    name: '刘先生',
    role: '退休教师',
    content: '界面简洁，操作方便，年纪大了也能轻松使用。纪录片和戏曲类内容对我胃口，每天都要看一会儿。',
    rating: 4,
  },
];

export default function AboutPage() {
  const [activeTab, setActiveTab] = useState<'intro' | 'testimonials' | 'contact'>('intro');

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于在线观看',
            description: '在线观看是一个专注于提供高清视频内容的在线平台，致力于为用户提供优质的在线观影体验。',
            url: 'https://www.zaixianguankan.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '在线观看',
              url: 'https://www.zaixianguankan.com',
            },
          }),
        }}
      />
      <Navbar />
      <main>
        <div className="pt-20 pb-8 bg-background-100/50 border-b border-background-200/60">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <Breadcrumb items={breadcrumbItems} />
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mt-4">
              关于我们
            </h1>
            <p className="text-sm text-foreground-600 mt-2">了解在线观看的品牌故事与团队使命</p>
          </div>
        </div>

        <div className="py-8">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200/60 mb-8">
              <button
                type="button"
                onClick={() => setActiveTab('intro')}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  activeTab === 'intro'
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-950'
                }`}
              >
                品牌介绍
              </button>
              <button
                type="button"
                onClick={() => setActiveTab('testimonials')}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  activeTab === 'testimonials'
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-950'
                }`}
              >
                用户口碑
              </button>
              <button
                type="button"
                onClick={() => setActiveTab('contact')}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  activeTab === 'contact'
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-950'
                }`}
              >
                联系我们
              </button>
            </div>

            {activeTab === 'intro' && (
              <section>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                  <div>
                    <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-4">
                      让每个人都能轻松享受高清内容
                    </h2>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      <strong>在线观看</strong>成立于2024年，是一家专注于提供高清视频内容的在线平台。我们致力于打破传统观影的壁垒，让用户无需下载任何软件，打开浏览器即可畅享海量高清影视、综艺、纪录片等内容。
                    </p>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      我们的团队由一群热爱影视内容的工程师和产品经理组成。他们来自国内外顶尖的互联网和媒体公司，拥有丰富的视频技术和内容运营经验。怀着对优质内容的执着追求，我们打造了这个集高品质、高流畅度、高便利性于一体的<strong>在线观看</strong>平台。
                    </p>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      截至目前，<strong>在线观看</strong>已积累超过<strong>10万部</strong>精选内容，覆盖电影、电视剧、综艺、纪录片、动漫、少儿六大品类，日均活跃用户突破<strong>5000万</strong>。我们采用全球领先的CDN加速技术，确保用户在手机、平板、电脑、电视等各个终端上都能获得流畅不卡顿的<strong>在线观看</strong>体验。
                    </p>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      我们坚信，优质的<strong>在线观看</strong>内容应该触手可及。无论你身处何地，使用何种设备，<strong>在线观看</strong>都将为你提供一致的、高品质的观影体验。无需下载、无广告打扰、4K超清画质——这就是我们想要带给每一位用户的价值。
                    </p>
                  </div>
                  <div className="relative overflow-hidden rounded-lg aspect-[4/3] bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20creative%20tech%20office%20workspace%20with%20diverse%20team%20collaborating%2C%20large%20monitors%20displaying%20video%20content%2C%20warm%20ambient%20lighting%2C%20minimalist%20industrial%20design%2C%20professional%20corporate%20photography%2C%20clean%20modern%20aesthetic&width=800&height=600&seq=about-brand-01&orientation=landscape"
                      alt="在线观看团队"
                      title="在线观看团队工作场景"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
                  {[
                    { num: '10万+', label: '精选内容' },
                    { num: '5000万+', label: '活跃用户' },
                    { num: '99.9%', label: '服务可用率' },
                    { num: '4K', label: '超清画质' },
                  ].map((stat) => (
                    <div key={stat.label} className="text-center p-6 rounded-lg bg-background-100 border border-background-200/60">
                      <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">{stat.num}</div>
                      <div className="text-sm text-foreground-600 mt-1">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {activeTab === 'testimonials' && (
              <section>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">
                  用户口碑
                </h2>
                <p className="text-sm text-foreground-600 mb-8">来自真实用户的评价与反馈</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {testimonials.map((t, i) => (
                    <div key={i} className="p-6 rounded-lg bg-background-100 border border-background-200/60">
                      <div className="flex items-center gap-1 mb-3">
                        {Array.from({ length: 5 }).map((_, idx) => (
                          <i
                            key={idx}
                            className={`text-sm ${idx < t.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-500'}`}
                          ></i>
                        ))}
                      </div>
                      <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                        &ldquo;{t.content}&rdquo;
                      </p>
                      <div className="flex items-center gap-3 pt-3 border-t border-background-200/60">
                        <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center">
                          <span className="text-xs font-bold text-accent-700">{t.name[0]}</span>
                        </div>
                        <div>
                          <div className="text-sm font-medium text-foreground-950">{t.name}</div>
                          <div className="text-xs text-foreground-600">{t.role}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {activeTab === 'contact' && (
              <section>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                  <div className="lg:col-span-1">
                    <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-4">
                      联系我们
                    </h2>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                      如有任何问题或建议，欢迎通过以下方式与我们取得联系。我们的客服团队将在24小时内回复您。
                    </p>
                    <div className="space-y-4">
                      <div className="flex items-start gap-3">
                        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                          <i className="ri-mail-line"></i>
                        </div>
                        <div>
                          <div className="text-sm font-medium text-foreground-950">电子邮箱</div>
                          <div className="text-sm text-foreground-600">contact@zaixianguankan.com</div>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                          <i className="ri-phone-line"></i>
                        </div>
                        <div>
                          <div className="text-sm font-medium text-foreground-950">客服电话</div>
                          <div className="text-sm text-foreground-600">400-888-0000</div>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                          <i className="ri-map-pin-line"></i>
                        </div>
                        <div>
                          <div className="text-sm font-medium text-foreground-950">公司地址</div>
                          <div className="text-sm text-foreground-600">北京市朝阳区科技园区创新路88号</div>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                          <i className="ri-time-line"></i>
                        </div>
                        <div>
                          <div className="text-sm font-medium text-foreground-950">工作时间</div>
                          <div className="text-sm text-foreground-600">周一至周五 9:00 - 18:00</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="lg:col-span-2">
                    <ContactForm />
                  </div>
                </div>
              </section>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    website_alt: '',
  });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (formData.website_alt.trim() !== '') {
      setStatus('success');
      return;
    }

    if (formData.message.length > 500) {
      setErrorMsg('留言内容不能超过500个字符');
      setStatus('error');
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const formUrl = 'https://readdy.ai/api/form/d9sp7gdlbrt1qcgaj7c0';
      const form = e.currentTarget as HTMLFormElement;
      const payload = new FormData(form);
      payload.delete('website_alt');

      const response = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(payload as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '', website_alt: '' });
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请稍后重试');
      setStatus('error');
    }
  };

  return (
    <form data-readdy-form id="contact-form" onSubmit={handleSubmit} className="p-6 rounded-lg bg-background-100 border border-background-200/60">
      <h3 className="text-lg font-bold text-foreground-950 font-heading mb-5">发送消息</h3>

      {status === 'success' && (
        <div className="mb-5 p-4 rounded-lg bg-accent-100/50 border border-accent-200/60">
          <p className="text-sm text-accent-700 flex items-center gap-2">
            <i className="ri-checkbox-circle-line"></i>
            消息已发送成功！我们会尽快回复您。
          </p>
        </div>
      )}
      {status === 'error' && errorMsg && (
        <div className="mb-5 p-4 rounded-lg bg-red-50 border border-red-200">
          <p className="text-sm text-red-700 flex items-center gap-2">
            <i className="ri-error-warning-line"></i>
            {errorMsg}
          </p>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <div>
          <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-950 mb-1.5">姓名</label>
          <input
            id="contact-name"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/60 text-sm text-foreground-950 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
            placeholder="请输入您的姓名"
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-950 mb-1.5">邮箱</label>
          <input
            id="contact-email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/60 text-sm text-foreground-950 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
            placeholder="请输入您的邮箱"
          />
        </div>
      </div>

      <div className="mb-4">
        <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-950 mb-1.5">主题</label>
        <input
          id="contact-subject"
          type="text"
          name="subject"
          value={formData.subject}
          onChange={handleChange}
          required
          className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/60 text-sm text-foreground-950 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
          placeholder="请输入消息主题"
        />
      </div>

      <div className="mb-4">
        <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-950 mb-1.5">
          留言
          <span className="text-foreground-500 font-normal ml-1">（最多500字）</span>
        </label>
        <textarea
          id="contact-message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          maxLength={500}
          rows={5}
          className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/60 text-sm text-foreground-950 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors resize-none"
          placeholder="请输入您的留言内容..."
        ></textarea>
        <p className="text-xs text-foreground-600 mt-1 text-right">{formData.message.length}/500</p>
      </div>

      <input
        type="text"
        name="website_alt"
        value={formData.website_alt}
        onChange={handleChange}
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="honeypot-field"
      />

      <button
        type="submit"
        disabled={status === 'loading'}
        className="w-full py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors whitespace-nowrap cursor-pointer"
      >
        {status === 'loading' ? (
          <span className="flex items-center justify-center gap-2">
            <i className="ri-loader-4-line animate-spin"></i>
            发送中...
          </span>
        ) : '发送消息'}
      </button>
    </form>
  );
}